export default function ({ $axios, app, i18n, $config, $device, $auth }, inject) {
    $axios.interceptors.request.use((request) => {
        request.meta = request.meta || {};
        request.meta.requestStartedAt = new Date().getTime();

        if (!$device.isSafari && !/^https/.test(request.url)) {
            request.headers.accept = 'image/webp';
        }

        return request;
    });

    $axios.onError((error) => {
        console.log('response error!');
        console.log(error);
    });

    $axios.defaults.baseURL = $config.baseURL + '/api';
}
